import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Popup from "reactjs-popup";
import { WARNING_DIALOG_TYPE } from "./helper";
import CustomSelect from "../Util/CustomSelect/CustomSelect";

export default function WarningDialogue(props) {
  const getButtonReschedule = (type) => {
    if (type === "reschedule") {
      return <>
        <button type='button' className='cancel-btn' onClick={() => props.action && props.action(false)}>
          Save Only
        </button>
        <button onClick={() => props.action && props.action(true)}>Save and Send SMS</button>
      </>;
    } else if (type === 'delete-schedule') {
      return <>
        <button type='button' className='cancel-btn' onClick={() => props.onClose && props.onClose(false)}>
          Cancel
        </button>
        <button type='button' className='cancel-btn' onClick={() => props.action && props.action(false)}>
          Delete
        </button>
        <button onClick={() => props.action && props.action(true)}>Delete and Send SMS</button>
      </>
    } else if (type === 'week-moved-reschedule') {
      return <>
        <button type='button' className='cancel-btn' onClick={() => props.action && props.action(props.data ? props.data : null ,false)}>
          Save Only
        </button>
        <button onClick={() => props.action && props.action((props.data ? props.data : null),true)}>Save and Send SMS</button>
      </>;
    }
  };
  return (
    <>
      <Popup closeOnDocumentClick={props.backdrop || false} open={props.isOpen} className={`${props && props?.type === WARNING_DIALOG_TYPE.ADD_PLAYER ? "wide-popup" : ""}`}>
        <div className='modal warning-popup'>
          <div className='modal-header'>
            <h2>{props.header}</h2>
            <span className='close' onClick={() => props.onClose && props.onClose(false)}>
              ×
            </span>
          </div>
          <div className='modal-body'>
            <div className='warning-message-field'>
              <FontAwesomeIcon icon={props.icon || faExclamationTriangle} className='warning-icon' />
              <p>{props.description}</p>
            </div>
          </div>
          {props && props?.type === WARNING_DIALOG_TYPE.ADD_PLAYER && (
            <>
              {props?.leagueSelect?.length > 0 && (
                <div className='add-adminModal cs-add-adminModal'>
                  <label className='user-label p-b-10'>User have registered for multiple leagues. Please choose one.</label>
                  <CustomSelect data={props?.leagueSelect} placeholder={props?.selectedLeague?.league_name ? props?.selectedLeague?.league_name : "Select League"} onSelect={(e) => e && props?.onLeagueSelect(e)} selector='league_name' />
                </div>
              )}
              <div className='add-adminModal cs-add-adminModal p-b-10 league-info'>
                <label className='cs-custom-checkbox' htmlFor='captain'>
                  <input type='checkbox' id='captain' onChange={(e) => props?.isCaptain(e.target.checked)} />
                  <span></span>Promote to captain
                </label>
                {props?.selectedLeague.id && (
                  <div>
                    {" "}
                    <strong>Paid Method:</strong> {props?.selectedLeague?.paid_by?.toUpperCase()}{" "}
                  </div>
                )}
              </div>
              {props?.selectedLeague.id && (
                <>
                  <div className='add-adminModal cs-add-adminModal league-info p-b-10'>
                    <div>
                      {" "}
                      <strong>Paid Status:</strong> {props?.selectedLeague?.payment_status?.toUpperCase()}{" "}
                    </div>
                    {props?.selectedLeague?.payment_status === "unpaid" && (
                      <div>
                        {" "}
                        <strong>Card Available:</strong> {props?.selectedLeague?.stripeToken?.toUpperCase()}{" "}
                      </div>
                    )}
                  </div>
                  <div className='add-adminModal cs-add-adminModal league-info p-b-10'>
                    {!props?.leagueSelect && props?.selectedLeague?.id && (
                      <div>
                        {" "}
                        <strong>Sign Up For:</strong> {props?.selectedLeague?.league.name}{" "}
                      </div>
                    )}
                  </div>
                  {props?.selectedLeague?.show_payment_button && (
                    <div className='add-adminModal cs-add-adminModal league-info p-b-10 individual-warning-msg'>
                      <label className='cs-custom-checkbox large' htmlFor='payment-checkbox'>
                        <input type='checkbox' name='payment-checkbox' id='payment-checkbox' onChange={(e) => props?.onCheckChange(e)} />
                        <span></span>Note: Payment for the individual has failed. Please mark the checkbox to send a payment link to the user. If you prefer to collect the payment manually, do not mark the checkbox.
                      </label>
                    </div>
                  )}
                </>
              )}
            </>
          )}
          <div className='modal-footer d-flex'>
            {!props?.type || (props?.type && !["reschedule", "delete-schedule", "week-moved-reschedule"].includes(props?.type)) ? (
              <>
                {!props.messageOnly && (
                  <button type='button' className='cancel-btn' onClick={() => props.onClose && props.onClose(false)}>
                    {" "}
                    {props.paymentWarning ? "Continue without Payment" : props.cancelButton ? props.cancelButton : "Cancel"}
                  </button>
                )}
                <button onClick={() => props.action && props.action(props.data ? props.data : null)} disabled={props?.type !== WARNING_DIALOG_TYPE.ADD_PLAYER || (props?.type === WARNING_DIALOG_TYPE.ADD_PLAYER && props?.selectedLeague?.id) || !props?.leagueSelect?.length ? false : true}>
                  {props.confirmButton ? props.confirmButton : "Confirm"}
                </button>
              </>
            ) : (
              <>{getButtonReschedule(props?.type)}</>
            )}
          </div>
        </div>
      </Popup>
    </>
  );
}
